

























































































































































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { required, email, minLength, requiredIf } from 'vuelidate/lib/validators';

import BaseInput from '@/components/ui/form/BaseInput.vue';
import BaseTextarea from '@/components/ui/form/BaseTextarea.vue';
import BaseDatepicker from '@/components/ui/form/BaseDatepicker.vue';
import BaseButton from '@/components/ui/buttons/Button.vue';
import BaseSelect from '@/components/ui/form/BaseSelect.vue';
import BaseCheckbox from '@/components/ui/form/BaseCheckbox.vue';
import IRequestForm from '@/store/modules/request/types/IRequestForm';

@Component({
  components: {
    BaseInput,
    BaseTextarea,
    BaseButton,
    BaseDatepicker,
    BaseSelect,
    BaseCheckbox,
  },
  validations: {
    senderCompany: {
      required,
    },
    senderContactPerson: {
      required,
    },
    senderContactPersonPosition: {
      required,
    },
    senderEmail: {
      required,
      email,
    },
    senderPhone: {
      required,
    },
    dateLoading: {
      required,
    },
    dateUnloading: {
      required,
    },
    fromCountry: {
      required,
    },
    fromCity: {
      required,
    },
    fromAddress: {
      requiredIf,
    },
    toCountry: {
      required,
    },
    toCity: {
      required,
    },
    toAddress: {
      requiredIf,
    },
    loadType: {
      required,
    },
    loadDescription: {
      required,
    },
    packageType: {
      required,
    },
    packageCount: {
      required,
    },
    packageWeight: {
      required,
    },
  },
})
export default class RequestForm extends Vue {
  @Prop({ type: Object, required: true }) private formData!: IRequestForm;

  private senderCompany: string = '';
  private senderContactPerson: string = '';
  private senderContactPersonPosition: string = '';
  private senderEmail: string = '';
  private senderPhone: string = '';
  private dateLoading: string = '';
  private dateUnloading: string = '';
  private fromCountry: string = '';
  private fromCity: string = '';
  private fromAddress: string = '';
  private toCountry: string = '';
  private toCity: string = '';
  private toAddress: string = '';
  private loadType: string = '';
  private loadDescription: string = '';
  private packageType: string = '';
  private packageCount: string = '';
  private packageWeight: string = '';
  private isDangerous: boolean = false;
  private isTemperature: boolean = false;
  private isBulk: boolean = false;

  private submit(): void {
    this.$store.dispatch('request/submit', {});
  }
}
